import GRadio from './GRadio.vue';

export default GRadio;

export { GRadio };
